export default function Footer() {
  return (
    <div className="relative block w-full py-[30px] bg-[#1D0D41]">
      <div className="container mx-auto xl:px-0 lg:px-8 md:px-6 px-4">
        <div className="flex justify-between items-center lg:flex-row flex-col">
          <p className="text-sm text-white text-center lg:mb-0 mb-3">
            © Copyright 2024 — Glocify Technologies – All Rights Reserved
          </p>
          <div className="flex items-center gap-4">
            <p className="text-sm text-white text-center">
              <a href="https://glocify.com/terms">Terms Conditions</a>
            </p>
            <p className="text-sm text-white text-center">
              <a href="https://glocify.com/privacy">Privacy Policy</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
